export default class Urls {
  static formatWithProtocol(link) {
    return !/^https?:\/\//i.test(link) ? `http://${link}` : link
  }
}
